<template>
    <div :class="'bizcomp-acct-manager bizcomp ' + className">
        <div class="acct-manager-head">
            <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#ffffff"
                text-color="#666666"
                active-text-color="var(--color-primary)"
                v-on:select="handleSelect"
            >
                <el-menu-item index="1">
                    <div :class="'height-63 ' + (activeIndex == '1' ? 'border-4' : '')">
                        账户信息
                    </div>
                </el-menu-item>
                <el-menu-item index="2">
                    <div :class="'height-63 ' + (activeIndex == '2' ? 'border-4' : '')">
                        账户安全
                    </div>
                </el-menu-item>
                <el-menu-item v-if="serviceBookingDisplay" index="3">
                    <div :class="'height-63 ' + (activeIndex == '3' ? 'border-4' : '')">
                        服务订阅
                    </div>
                </el-menu-item>
                <el-submenu v-if="$util.getConfig().hideFunc" index="4">
                    <template slot="title">
                        <div class="bank-name-tip" style="display: flex; align-items: center">
                            银行卡
                            <i
                                :class="
                                    'el-icon-arrow-down own-icon-arrow-down ' +
                                    (activeIndex.length === 3 ? 'color-e60012' : '')
                                "
                            ></i>
                        </div>
                    </template>
                    <div class="el-menu-group">
                        <el-menu-item index="4-1">银行卡列表</el-menu-item>
                        <el-menu-item v-if="changeCardDisplay" index="4-2">换卡管理</el-menu-item>
                        <el-menu-item v-if="$util.getBusinessModule('0A3')" index="4-3">
                            银行卡签约/解约
                        </el-menu-item>
                        <el-menu-item v-if="$cache.getUser().certificatetype == '00'" index="4-4">
                            身份证号位数转换
                        </el-menu-item>
                    </div>
                </el-submenu>
                <el-submenu v-if="$util.getFundClass() == '1'" index="6" style="width: 180px">
                    <template slot="title">
                        <div class="bank-name-tip" style="display: flex; align-items: center">
                            协议/合同列表
                            <i
                                :class="
                                    'el-icon-arrow-down own-icon-arrow-down ' +
                                    (activeIndex.length === 3 ? 'color-e60012' : '')
                                "
                            ></i>
                        </div>
                    </template>
                    <div class="el-menu-group">
                        <el-menu-item index="6-1">协议列表</el-menu-item>
                        <el-menu-item index="6-2">电子合同列表</el-menu-item>
                    </div>
                </el-submenu>
                <el-menu-item v-if="$util.getConfig().hideFunc" index="5">
                    <div :class="'height-63 ' + (activeIndex == '5' ? 'border-4' : '')">
                        注销账户
                    </div>
                </el-menu-item>
            </el-menu>
        </div>
        <div class="bottom-info">
            <acct-info-dc v-if="activeIndex == '1'"></acct-info-dc>
            <acct-security-dc v-if="activeIndex == '2'"></acct-security-dc>
            <service-subscript v-if="activeIndex == '3'"></service-subscript>
            <bank-dc v-if="activeIndex == '4-1'"></bank-dc>
            <unsubscribe v-if="activeIndex == '5'"></unsubscribe>
            <agreement-list v-if="activeIndex == '6-1'"></agreement-list>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import AcctInfoDc from "./accInfoDc.vue";
import AcctSecurityDc from "./acctSecurityDc.vue";
import ServiceSubscript from "./serviceSubscript.vue";
import BankDc from "./bankDc.vue";
import Unsubscribe from "./unsubscribe.vue";
import AgreementList from "./agreementList.vue";
export default {
    name: "AcctManager",
    components: {
        AcctInfoDc,
        AcctSecurityDc,
        ServiceSubscript,
        BankDc,
        Unsubscribe,
        AgreementList
    },
    mixins: [mixin],
    data() {
        return {
            activeIndex: "1",
            serviceBookingDisplay: false, // 控制服务订阅入口是否显示
            changeCardDisplay: false // 换卡管理是否展示
        };
    },
    watch: {
        "$route.query.activeIndex"(val) {
            this.activeIndex = this.$route.query.activeIndex ? this.$route.query.activeIndex : "1";
            this.$route.query.activeIndex = this.activeIndex;
        }
    },
    mounted() {
        this.activeIndex = this.$route.query.activeIndex ? this.$route.query.activeIndex : "1";
        this.$route.query.activeIndex = this.activeIndex;
        this.serviceBookingDisplay =
            this.$cache.getParamValue("customized_server") &&
            this.$cache.getParamValue("customized_server").customized_server &&
            this.$cache.getParamValue("customized_server").customized_server.length > 0; // 服务订阅内容有配置才显示

        const accountInfo = this.$cache.getParamValue("account_info");
        if (accountInfo && accountInfo.showchangebankcard) {
            this.changeCardDisplay = true;
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            this.activeIndex = key;
            if (key == "4-2") {
                this.$router.push({
                    name: "changecardlist"
                });
            } else if (key == "4-3") {
                this.$router.push({
                    name: "signandunsign"
                });
            } else if (key == "4-4") {
                this.$router.push({
                    name: "idnumbertran"
                });
            } else if (key == "6-2") {
                this.$router.push({
                    name: "contract"
                });
            } else {
                this.$router.push({
                    path: this.$route.path,
                    query: { activeIndex: this.activeIndex }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.el-menu-group {
    display: flex;
    position: relative;
    left: 10px;
    padding-right: 20px;
    .el-menu-item {
        background-color: rgba(255, 255, 255, 0) !important;
    }
    :deep(.el-menu-item:hover) {
        color: var(--color-primary) !important;
        background-color: rgba(255, 255, 255, 0) !important;
    }
}

.bizcomp-acct-manager {
    .acct-manager-head {
        height: 70px;
        padding-bottom: 7px;
        border: 1px solid #f1f1f1;
        box-sizing: border-box;
        width: 1198px;
    }

    :deep(.el-menu) {
        border: none;
    }

    :deep(.is-active) {
        color: var(--color-primary) !important;
        .el-submenu__title {
            border: none;
        }
        .bank-name-tip {
            border-bottom: 4px solid var(--color-primary) !important;
            .el-icon-arrow-down {
                margin: 0;
                text-align: right;
            }
        }
    }

    :deep(.el-submenu__title:hover) {
        color: var(--color-primary) !important;
        .own-icon-arrow-down {
            color: var(--color-primary) !important;
        }
    }
    :deep(.isopened) {
        color: #cccccc !important;
    }
    :deep(.el-submenu__icon-arrow) {
        color: #ffffff !important;
    }
    :deep(.el-submenu__title) {
        display: flex;
        align-items: center;
    }
    :deep(.el-submenu) {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 59px;
        line-height: 59px;
        border: none;
    }
    :deep(.el-submenu__title) {
        background-color: #ffffff !important;
        font-size: 20px !important;
        color: #666;
    }
    .el-menu-item {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 59px;
        line-height: 59px;
        font-size: 20px;
        color: #666;
        border: none;
        background-color: #ffffff !important;
    }
    .el-menu-item:hover {
        color: var(--color-primary) !important;
        background-color: #ffffff !important;
    }
    :deep(.is-active) {
        color: var(--color-primary);
        font-weight: 500;
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .border-4 {
        border-bottom: 4px solid var(--color-primary);
    }
    .height-63 {
        width: 80px;
        height: 59px;
        margin: auto;
    }
    .bottom-info {
        padding: 21px 16px 20px 20px;
        width: 1198px;
        box-sizing: border-box;
    }
}
</style>
